// Messages for the customer-portal shell chrome (auto-merged by lib/i18n.ts).
export const en = {
  'portal.shell.subtitle': 'Customer Portal',
  'portal.shell.search': 'Search shipments, quotes, invoices…',
  'portal.section.account': 'Account',
  'portal.nav.account': 'Account',
  'portal.nav.settings': 'Settings',
  'portal.nav.conversations': 'Conversations',
  'portal.nav.quotes': 'Quotes',
  'portal.nav.invoices': 'Invoices',
}

export const zhTW = {
  'portal.shell.subtitle': '客戶入口',
  'portal.shell.search': '搜尋貨件、報價、發票…',
  'portal.section.account': '帳戶',
  'portal.nav.account': '帳戶',
  'portal.nav.settings': '設定',
  'portal.nav.conversations': '對話',
  'portal.nav.quotes': '報價',
  'portal.nav.invoices': '發票',
}
